import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import AccessTemplateSelection from "../../../components/BuilderComponents/AccessTemplateSelection";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import IconPreview, { AddAndDeleteInlineIcon } from "../../../components/BuilderComponents/Preview/IconPreview";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import Label from "../../../components/FormComponents/Label";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { useAxiosContext } from "../../../context/AxiosContext";
import { useModalContext } from "../../../context/ModalContext";
import { useScreenContext } from "../../../context/ScreenContext";
import { useTreeContext } from "../../../context/TreeDataContext";
import { getAllScreens } from "../../../utils/screenutils";
import "../Header.css";
import NewHeaderRenderer, { ScreenHeaderMenu } from "./NewHeaderRenderer";
import { generateObjectId } from "../../../utils/objectIdUtils";

const NewScreenHeader = ({ currentScreenData, saveScreenJson }) => {
  const [allPages, setAllPages] = useState([]);
  const { orgId } = useParams();
  const { screensExplorerData } = useTreeContext();
  const { selectedScreen, setCurrentScreenData } = useScreenContext();
  const { axiosInstance } = useAxiosContext();
  const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedTab, setSelectedTab] = useState("1");
  const [options, setOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [moduleActionModal, setModuleActionModal] = useState({
    show: false,
    type: "",
    module_id: ""
  });

  const moduleHeaderConfig = currentScreenData?.module_header_config || [];

  // const handleSaveModule = (moduleData) => {
  //   moduleData.id = generateObjectId();
  //   moduleData.tab = selectedTab;

  //   if (moduleActionModal.type === "add") {
  //     setModuleHeaderConfig([...moduleHeaderConfig, moduleData]);
  //     setSelectedModule(moduleData.id);
  //   } else if (moduleActionModal.type === "edit") {
  //     const updatedModules = moduleHeaderConfig.map((module) =>
  //       module.id === moduleActionModal.module_id ? moduleData : module
  //     );
  //     setModuleHeaderConfig(updatedModules);
  //     setSelectedModule(moduleData.id);
  //   }
  //   closeModuleModal();
  // };

  const handleSaveModule = (moduleData) => {
    moduleData.id = generateObjectId();
    moduleData.tab = selectedTab;

    setCurrentScreenData((prev) => {
      const currentModules = prev.module_header_config;

      switch (moduleActionModal.type) {
        case "add":
          return {
            ...prev,
            module_header_config: [...currentModules, moduleData]
          };

        case "edit":
          return {
            ...prev,
            module_header_config: currentModules.map((module) =>
              module.id === moduleActionModal.module_id ? moduleData : module
            )
          };

        default:
          return prev; // No changes for unknown types
      }
    });

    setSelectedModule(moduleData.id);
    closeModuleModal();
  };

  useEffect(() => {
    setSelectedModule(null);
  }, [selectedTab]);

  const handleOpenAddModal = () => {
    setModuleActionModal({ show: true, type: "add" });
  };
  const handleShowModulesInSidebarChange = () => {
    setCurrentScreenData((prev) => ({
      ...prev,
      show_modules_in_sidebar: !prev?.show_modules_in_sidebar
    }));
  };

  const getModuleData = () => {
    if (moduleActionModal.type === "edit" && selectedModule) {
      return moduleHeaderConfig.find((module) => module.id === selectedModule);
    }
    return null;
  };

  const closeModuleModal = () => {
    setModuleActionModal({ ...moduleActionModal, show: false, type: "" });
  };

  const fetchAllPages = async () => {
    // const index = currentScreenData.device === "desktop" ? 0 : 1;
    const allScreens = getAllScreens(screensExplorerData.find((s) => s.id === currentScreenData.device)?.items || []);
    // const allScreens = getAllScreens(screensExplorerData[index].items);
    // setAllPages(screensExplorerData[index].items);
    setAllPages(allScreens);
  };

  useEffect(() => {
    fetchAllPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentScreenData.device]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axiosInstance.get(`user-service/groups/org/${orgId}`);
        setOptions(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return (
    <>
      <div className="screen_body_main screen-center-wrapper">
        <PageInfoAndActionBar
          pagePath={`Screens/${selectedScreen?.name}`}
          savePage={saveScreenJson}
          settingPage={() => setIsSettingModalOpen(true)}
          // currentConfig={[
          //   currentScreenData?.header_config,
          //   currentScreenData?.z_admin_config,
          //   currentScreenData?.module_header_config
          // ]}
          // pageName="screen"
        />
        <div className="screen_action_bar_top">
          <div className="m_auto mt_2 ml_3 d_flex align_center gap_3">
            <Button onClick={handleOpenAddModal} variant="secondary">
              Add Module
            </Button>
            <Input
              type="checkbox"
              label="Show Modules in Sidebar"
              checked={currentScreenData?.show_modules_in_sidebar || false}
              onChange={handleShowModulesInSidebarChange}
              inputBoxStyle={{ cursor: "pointer" }}
              labelClassName="cursor_pointer"
            />
          </div>
          <div className="gap_3 p_3 ml_auto flex_row_justify_center_align_center mt_2">
            <SingleSelectBox
              placeholder="Select Group"
              selectedData={selectedGroup || ""}
              options={options}
              onChange={(grp) => {
                setSelectedGroup(grp.id);
              }}
            />
            <HeaderMenuAlignment
              headerConfig={currentScreenData?.header_config}
              setCurrentScreenData={setCurrentScreenData}
            />
          </div>
        </div>
        <div className="screens_page_outer page_main_section screen-header-outer">
          <div className={currentScreenData.device === "desktop" ? "desktop_screen_header" : "mobile_screen_header"}>
            {currentScreenData.device === "mobile" && (
              <div className="sidebar_tab_buttons mb_4 w_50">
                {["1", "0"].map((tab) => (
                  <div
                    key={tab}
                    className={`sidebar_tabs ${selectedTab === tab ? "active" : ""}`}
                    onClick={() => setSelectedTab(tab)}
                  >
                    {tab === "1" ? "Edit Side Bar" : "Edit Bottom Bar"}
                  </div>
                ))}
              </div>
            )}
            <NewHeaderRenderer
              allPages={allPages}
              //   setSubMenuFlag={setSubMenuFlag}
              // moduleHeaderConfig={moduleHeaderConfig}
              selectedModule={selectedModule}
              currentScreenData={currentScreenData}
              selectedTab={selectedTab}
              selectedGroup={selectedGroup}
            />

            <ModuleBasedScreenHeader allPages={allPages} selectedTab={selectedTab} />
          </div>
        </div>
      </div>
      <BuilderModal
        isOpen={isSettingModalOpen}
        onClose={() => setIsSettingModalOpen(false)}
        modalName="Header Settings"
      >
        <ZadminConfig />
      </BuilderModal>
      <BuilderModal
        isOpen={moduleActionModal.show}
        onClose={closeModuleModal}
        modalName={moduleActionModal.type === "add" ? "Create Module" : "Edit Module"}
      >
        <AddEditModule moduleData={getModuleData()} onSave={handleSaveModule} device={currentScreenData.device} />
      </BuilderModal>
    </>
  );
};

export const ModuleBasedScreenHeader = ({ allPages, selectedTab }) => {
  const { currentScreenData, setCurrentScreenData } = useScreenContext();
  const { getUserConfirmationForDelete } = useModalContext();
  const moduleHeaderConfig = currentScreenData?.module_header_config || [];
  const [moduleActionModal, setModuleActionModal] = useState({ show: false, type: "", module_id: "" });
  const [selectedModule, setSelectedModule] = useState(null);

  const filteredModuleOptions = moduleHeaderConfig.filter(
    (module) =>
      (selectedTab === "1" ? module.config.menu.length : module.config.menu_bottom.length) > 0 ||
      module.tab === selectedTab
  );

  useEffect(() => {
    setSelectedModule(null);
  }, [selectedTab]);

  const setModuleHeaderConfig = (newModuleHeaderConfig) => {
    setCurrentScreenData((prev) => ({
      ...prev,
      module_header_config:
        typeof newModuleHeaderConfig === "function"
          ? newModuleHeaderConfig(prev.module_header_config)
          : newModuleHeaderConfig
    }));
  };

  const updateModuleData = (data) => {
    const updatedModules = moduleHeaderConfig.map((mod) =>
      mod.id === selectedModule
        ? { ...mod, config: { ...mod.config, [selectedTab === "1" ? "menu" : "menu_bottom"]: data } }
        : mod
    );
    setModuleHeaderConfig(updatedModules);
  };

  const handleSaveModule = (moduleData) => {
    moduleData.id = generateObjectId();
    moduleData.tab = selectedTab;

    const updatedModules =
      moduleActionModal.type === "add"
        ? [...moduleHeaderConfig, moduleData]
        : moduleHeaderConfig.map((module) =>
            module.id === moduleActionModal.module_id ? { ...module, ...moduleData } : module
          );

    setModuleHeaderConfig(updatedModules);
    setSelectedModule(moduleData.id);
    closeModuleModal();
  };

  const closeModuleModal = () => {
    setModuleActionModal({ show: false, type: "" });
  };

  const deleteModule = async (id, name) => {
    const userConfirmed = await getUserConfirmationForDelete(name);
    if (userConfirmed) {
      const filteredModules = moduleHeaderConfig.filter((module) => module.id !== id);
      setModuleHeaderConfig(filteredModules);
    }
  };

  const handleModuleSelection = (moduleId) => {
    setSelectedModule((prevSelected) => (prevSelected === moduleId ? null : moduleId));
  };

  return (
    <div className="mt_4">
      <div className="d_flex mt_3 mb_3 align_center">
        {moduleHeaderConfig.length > 0 && <Label style={{ fontSize: "16px", fontWeight: "500" }}>All Modules</Label>}
      </div>
      {filteredModuleOptions.map((module) => (
        <div key={module.id}>
          <div className="d_flex mt_3 mb_1 align_center" style={{ fontWeight: "500", fontSize: "14px" }}>
            {module.name}
          </div>
          <div>
            <div
              className="module-container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                border: `1px solid ${
                  selectedModule === module.id ? "var(--builder-light-text)" : "var(--builder-border)"
                }`,
                cursor: "pointer",
                width: "100%",
                position: "relative"
              }}
              onClick={() => handleModuleSelection(module.id)}
            >
              {selectedModule === module.id ? (
                <div className="ml_auto mr_2" onClick={(e) => e.stopPropagation()}>
                  <ScreenHeaderMenu
                    allPages={allPages}
                    updateHeaderData={updateModuleData}
                    menu={module.config[selectedTab === "1" ? "menu" : "menu_bottom"]}
                    currentScreenData={currentScreenData}
                    selectedTab={selectedTab}
                  />
                </div>
              ) : (
                <div className="screen_header_options add_headers">
                  {(selectedTab === "1" ? module.config.menu : module.config.menu_bottom).map((item, index) => (
                    <div key={index} className="d_flex align_center">
                      <div className="d_flex gap_1 align_center">
                        <div>{item.icon && <IconPreview icon={item.icon} />}</div>
                        <div className="header_menu_item screen_header_item">{item.display}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="action-buttons-container">
                <ButtonActionIcon
                  type="edit"
                  onClick={() => setModuleActionModal({ show: true, type: "edit", module_id: module.id })}
                  size="xsm"
                />
                <ButtonActionIcon type="delete" onClick={() => deleteModule(module.id, module.name)} size="xsm" />
              </div>
            </div>
          </div>
        </div>
      ))}

      <BuilderModal
        isOpen={moduleActionModal.show}
        onClose={closeModuleModal}
        modalName={moduleActionModal.type === "add" ? "Create Module" : "Edit Module"}
      >
        <AddEditModule
          moduleData={
            moduleActionModal.type === "edit"
              ? moduleHeaderConfig.find((module) => module.id === moduleActionModal.module_id)
              : null
          }
          onSave={handleSaveModule}
          device={currentScreenData.device}
        />
      </BuilderModal>
    </div>
  );
};

export const AddEditModule = ({ moduleData, onSave }) => {
  const [selectedIcon, setSelectedIcon] = useState(moduleData?.icon || "");

  const initialModuleData = moduleData
    ? {
        ...moduleData,
        config: {
          ...moduleData.config,
          menu: JSON.stringify(moduleData.config.menu, null, 2),
          menu_bottom: JSON.stringify(moduleData.config.menu_bottom, null, 2)
        }
      }
    : {
        name: "",
        description: "",
        icon: "",
        config: {
          menu: JSON.stringify([], null, 2),
          menu_bottom: JSON.stringify([], null, 2)
        },
        access_templates: []
      };

  const [newModuleData, setNewModuleData] = useState(initialModuleData);
  const [error, setError] = useState({
    name: null,
    menu: null,
    menu_bottom: null
  });

  const callbackFunction = (data) => {
    setSelectedIcon(data);
    setNewModuleData({ ...newModuleData, icon: data });
  };

  const handleModuleChangeData = (e) => {
    const { name, value } = e.target;
    if (name === "menu" || name === "menu_bottom") {
      setNewModuleData({
        ...newModuleData,
        config: { ...newModuleData.config, [name]: value }
      });
    } else {
      setNewModuleData({ ...newModuleData, [name]: value });
    }
  };

  const handleAccessTemplate = (data) => {
    setNewModuleData({ ...newModuleData, access_templates: data });
  };

  const saveModule = () => {
    const errors = {
      name: null,
      menu: null,
      menu_bottom: null
    };

    // Validate the module name
    const trimmedName = newModuleData.name.trim();
    if (trimmedName.length === 0) {
      errors.name = "Module name cannot be empty";
    }

    // Validate JSON configurations
    try {
      JSON.parse(newModuleData.config.menu || "[]");
    } catch {
      errors.menu = "Invalid JSON format in menu configuration";
    }

    try {
      JSON.parse(newModuleData.config.menu_bottom || "[]");
    } catch {
      errors.menu_bottom = "Invalid JSON format in menu_bottom configuration";
    }

    if (Object.values(errors).some((error) => error !== null)) {
      setError(errors);
      return;
    }

    // Clear errors if validation passes
    setError({
      name: null,
      menu: null,
      menu_bottom: null
    });

    // Save module data
    const parsedModuleData = {
      ...newModuleData,
      config: {
        menu: JSON.parse(newModuleData.config.menu || "[]"),
        menu_bottom: JSON.parse(newModuleData.config.menu_bottom || "[]")
      }
    };

    onSave(parsedModuleData);
  };

  return (
    <div className="builder_form">
      <Label>Enter Module Name</Label>
      <div className="d_flex">
        <AddAndDeleteInlineIcon icon={selectedIcon || ""} callbackFunction={callbackFunction} />
        <Input
          inputClassName="border_left_none outline_none"
          value={newModuleData.name}
          name="name"
          onChange={handleModuleChangeData}
        />
      </div>
      {error.name && (
        <div className="error" style={{ color: "red" }}>
          {error.name}
        </div>
      )}
      <AccessTemplateSelection templates={newModuleData.access_templates} handleChange={handleAccessTemplate} />
      {error.menu && (
        <div className="error" style={{ color: "red" }}>
          {error.menu}
        </div>
      )}

      <Button onClick={saveModule}>Save</Button>
    </div>
  );
};

export const HeaderMenuAlignment = ({ headerConfig, setCurrentScreenData }) => {
  const radioOptions = [
    { id: "top-right", name: "Top Right" },
    { id: "top-left", name: "Top Left" },
    { id: "left", name: "Left Vertical" }
  ];

  const handleNavPositionChange = (value) => {
    // setHeaderConfig({
    //   ...headerConfig,
    //   style: { ...headerConfig.style, nav_position: value, nav_fixed: true }
    // });
    setCurrentScreenData((prev) => ({
      ...prev,
      header_config: {
        ...prev.header_config,
        style: { ...prev.header_config.style, nav_position: value, nav_fixed: true }
      }
    }));
  };

  const handleShowAppNameChange = () => {
    setCurrentScreenData((prev) => ({
      ...prev,
      header_config: {
        ...prev.header_config,
        show_app_name: !prev.header_config.show_app_name
      }
    }));
  };

  return (
    <div style={{ margin: "0px", display: "flex", alignItems: "center", gap: "12px" }}>
      <Input
        type="checkbox"
        label="Show App Name"
        checked={headerConfig?.show_app_name || false}
        onChange={handleShowAppNameChange}
        containerClassName="mr_2"
        inputBoxStyle={{ cursor: "pointer" }}
        labelClassName="cursor_pointer"
      />
      <div style={{ width: "220px" }}>
        <SingleSelectBox
          options={radioOptions}
          selectedData={radioOptions.find((option) => option.id === headerConfig.style.nav_position) || null}
          onChange={(selectedOption) => handleNavPositionChange(selectedOption.id)}
          placeholder="Select Position"
        />
      </div>
    </div>
  );
};

export const ZadminConfig = () => {
  const { currentScreenData, setCurrentScreenData } = useScreenContext();
  const [selectedZadminData, setSelectedZadminData] = useState([]);

  const zAdminConfig = currentScreenData?.z_admin_config;

  const Zadmin = [
    { id: "user_management", name: "User Management" },
    { id: "metrics", name: "Metrics" },
    { id: "master_data", name: "Master Data" },
    { id: "web_hooks", name: "Web Hooks" },
    { id: "file_management", name: "File Management" },
    { id: "action_button", name: "Action button" }
  ];

  // Function to convert zAdminConfig.menu IDs to full objects
  const convertToSelectedData = (menu) => {
    return menu.map((id) => Zadmin.find((item) => item.id === id)).filter(Boolean);
  };

  const callbackfunction = (data) => {
    const selectedDataOfId = data.map((menu) => menu.id);
    // setZadminConfig({ ...zAdminConfig, menu: selectedDataOfId });
    setCurrentScreenData((prev) => ({
      ...prev,
      z_admin_config: { ...prev.z_admin_config, menu: selectedDataOfId }
    }));
    setSelectedZadminData(data);
  };

  useEffect(() => {
    if (zAdminConfig?.menu) {
      const convertedData = convertToSelectedData(zAdminConfig.menu);
      setSelectedZadminData(convertedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zAdminConfig]);

  return (
    <MultiSelectBox
      options={Zadmin}
      selectedData={selectedZadminData}
      onChange={callbackfunction}
      label="Zadmin Configuration"
    />
  );
};

export default NewScreenHeader;
